import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { formatDateAt } from "simplydo/core/dates";
import { groupCoverImage } from "simplydo/core/images";
import { RichTextViewer } from "simplydo/react/richtext";

import { UserChip } from "components/lib/Chips";

import { FeedItemOfType } from "../types";
import {
  FeedItem,
  FeedItemContent,
  FeedItemDate,
  FeedItemIcon,
  FeedItemMessage,
} from "./FeedItemUI";

type GroupActivityFeedPostFeedItemProps = {
  item: FeedItemOfType<"groupActivityFeedPost">;
};

const GroupActivityFeedPostFeedItem = ({
  item,
}: GroupActivityFeedPostFeedItemProps) => {
  const { t } = useTranslation();
  return (
    <FeedItem>
      <FeedItemIcon
        pinned={item.isPinned}
        src={groupCoverImage(item.ownerGroup)}
      />
      <FeedItemContent>
        <FeedItemMessage>
          <b>
            <UserChip user={item.owner} compact="very" />
          </b>{" "}
          <span>
            posted a message to{" "}
            <Link to={`/groups/${item.ownerGroup?._id}/feed`}>
              {item.ownerGroup?.name || t("groups.activityFeed.thisGroup")}
            </Link>
            .
          </span>
        </FeedItemMessage>
        <RichTextViewer restrictInitialContentHeight value={item.message} />
        <FeedItemDate>{formatDateAt(item.createdAt)}</FeedItemDate>
      </FeedItemContent>
    </FeedItem>
  );
};

export default GroupActivityFeedPostFeedItem;
